// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nEBAJmm0u7nU3ghKQB1W{width:492px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/inboxes/pages/newInbox/ui/SelectAppAndNumbers/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,WAAA","sourcesContent":[".root {\n  width: 492px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `nEBAJmm0u7nU3ghKQB1W`
};
export default ___CSS_LOADER_EXPORT___;
